export function formatUsd(micro: string | number | bigint, compact = false): string {
  const v = typeof micro === "bigint" ? micro : BigInt(Math.trunc(Number(micro) || 0));
  const neg = v < 0n;
  const abs = neg ? -v : v;
  const dollars = abs / 1_000_000n;
  const cents = (abs % 1_000_000n) / 10_000n;
  if (compact && dollars >= 1_000_000n) {
    const n = Number(dollars) / 1_000_000;
    return `${neg ? "-" : ""}$${n.toFixed(n >= 10 ? 1 : 2)}M`;
  }
  if (compact && dollars >= 1_000n) {
    const n = Number(dollars) / 1_000;
    return `${neg ? "-" : ""}$${n.toFixed(n >= 10 ? 1 : 2)}K`;
  }
  const whole = dollars.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `${neg ? "-" : ""}$${whole}.${cents.toString().padStart(2, "0")}`;
}

export function signedUsd(micro: string | number | bigint): string {
  const v = typeof micro === "bigint" ? micro : BigInt(Math.trunc(Number(micro) || 0));
  const body = formatUsd(v < 0n ? -v : v);
  if (v > 0n) return `+${body}`;
  if (v < 0n) return `-${body}`;
  return body;
}

export function formatShares(n: number): string {
  return n.toLocaleString();
}
